import BasicLayout from "@/layouts/basic-layout";
const meta = {
  auth: true
};
const pre = "dashboard-";
export default {
  path: "/dashboard",
  name: "dashboard",
  redirect: {
    name: `${pre}index`
  },
  meta,
  component: BasicLayout,
  children: [{
    path: "dashboard-index",
    name: `${pre}-index`,
    meta: {
      ...meta,
      title: "仪表盘"
    },
    component: () => import("@/pages/dashboard/dashboard")
  }]
};